module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-avatar-03-201b810027576af4fa75659078534fb8.png";